"use client";

import React from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";

export const PasswordInput = React.forwardRef(
  ({ className, value, onChange, showPassword, onToggleVisibility, disabled, ariaLabel, ...props }, ref) => {
    return (
      <div className="relative">
        <Input
          ref={ref}
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={onChange}
          className={cn("h-10 border-gray-300 focus:border-gray-400 pr-10", className)}
          disabled={disabled}
          {...props}
        />
        <button
          type="button"
          onClick={onToggleVisibility}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 transition-colors"
          disabled={disabled}
          aria-label={ariaLabel || (showPassword ? "Hide password" : "Show password")}
        >
          {showPassword ? (
            <EyeOff className="h-4 w-4" />
          ) : (
            <Eye className="h-4 w-4" />
          )}
        </button>
      </div>
    );
  }
);

PasswordInput.displayName = 'PasswordInput';
